import React, {PureComponent} from 'react';
import Panel from './Panel';
import {PieChart, Pie, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import * as TextManager from "../modules/languages/TextManager";

const data01 = [{name: 'Chrome', value: 12934, fill: '#4ce1b6'},
    {name: 'Safari', value: 9934, fill: '#70bbfd'},
    {name: 'Mozilla', value: 20432, fill: '#f6da6e'},
    {name: 'IE', value: 15432, fill: '#ff4861'}];

const colors = ['#4ce1b6', '#70bbfd', '#f6da6e', '#ff4861', '#9c70fd', '#d13cc4', '#e0fd70', '#fd9c70'];

const style = {
    left: 0,
    width: 150,
    lineHeight: '24px'
};

const renderLegend = (props) => {
    const {payload} = props;
    return (
        <ul className='dashboard__chart-legend'>
            {
                payload.map((entry, index) => (
                    <li key={`item-${index}`}><span style={{backgroundColor: entry.color}}/>{entry.value}</li>
                ))
            }
        </ul>
    );
};

export default class ProvidersStat extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            data: this.buildData(),
            total: this.total()
        };
    }


    buildData = () => {
        let tmp = [];
        for(let indx in this.props.data){
            tmp.push({name: this.props.data[indx].key, value: parseInt(this.props.data[indx].value), fill: colors[indx]});
        }

        return tmp;
    };

    total = () => {
      let tmp = 0;
        for(let indx in this.props.data){
            tmp +=  parseInt(this.props.data[indx].value);
        }

        return tmp;
    };

    render() {
        return (
            <Panel lg={6} xl={4} md={12}>
                <div className='dashboard__visitors-chart'>
                    <p className='dashboard__visitors-chart-title'>{TextManager.getCurrentTextResource().Text.totalDeals}</p>
                    <p className='dashboard__visitors-chart-number'>{this.state.total}</p>
                    <ResponsiveContainer className='dashboard__chart-pie' width='100%' height={220}>
                        <PieChart className='dashboard__chart-pie-container'>
                            <Tooltip/>
                            <Pie data={this.state.data} dataKey='value' cy={110} innerRadius={70} outerRadius={100}/>
                            <Legend layout='vertical' verticalAlign='bottom' wrapperStyle={style}
                                    content={renderLegend}/>
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </Panel>
        )
    }
}

